import {Navbar} from "../../Components/Navbar/Navbar";
import {Footer} from "../../Components/Footer/footer";

export function JuridicPage() {
    return (
        <div className="page-container">
            <Navbar/>
            <div className={"page-content"}>
                <h1>Juridic</h1>
                <p>Juridic</p>
            </div>
            <Footer/>
        </div>
    )
}